import { Link } from "react-router-dom";
import { Leaf, Phone, Mail, MapPin, Clock } from "lucide-react";
import { NAV, CONTACT, LOGO, PROMISE } from "@/data/site";
import { useLeadModal } from "@/context/LeadModalProvider";

export const Footer = () => {
  const { openBooking, openQuote } = useLeadModal();
  return (
    <footer className="relative bg-navy text-white overflow-hidden grain" data-testid="footer">
      <div className="max-w-7xl mx-auto px-5 sm:px-8 py-16 relative z-10">
        <div className="grid lg:grid-cols-4 gap-12">
          <div className="lg:col-span-2 max-w-md">
            <div className="inline-flex bg-white rounded-2xl p-4 mb-5">
              <img src={LOGO} alt="CJB Clean" className="h-16 w-auto object-contain" />
            </div>
            <p className="text-white/70 leading-relaxed">
              Healthy Spaces. Smarter Solutions. Reliable Service. Professional eco-friendly cleaning
              designed to leave your space healthier — not just looking clean.
            </p>
            <div className="flex items-center gap-2 mt-5 text-leaf">
              <Leaf className="w-4 h-4" />
              <span className="text-sm font-medium tracking-wide">Green Cleaning included on every job</span>
            </div>
          </div>

          <div>
            <h4 className="text-xs uppercase tracking-[0.2em] text-white/50 mb-5">Explore</h4>
            <ul className="space-y-3">
              {NAV.map((n) => (
                <li key={n.to}>
                  <Link to={n.to} className="text-white/80 hover:text-leaf transition-colors">{n.label}</Link>
                </li>
              ))}
            </ul>
          </div>

          <div>
            <h4 className="text-xs uppercase tracking-[0.2em] text-white/50 mb-5">Get in touch</h4>
            <ul className="space-y-3 text-white/80">
              <li className="flex items-start gap-3"><MapPin className="w-4 h-4 text-leaf mt-1 shrink-0" /><span data-testid="footer-address">{CONTACT.area}</span></li>
              <li className="flex items-center gap-3"><Phone className="w-4 h-4 text-leaf" /><a href={CONTACT.phoneHref} className="hover:text-leaf">{CONTACT.phone}</a></li>
              <li className="flex items-center gap-3"><Mail className="w-4 h-4 text-leaf" /><a href={`mailto:${CONTACT.email}`} className="hover:text-leaf">{CONTACT.email}</a></li>
              <li className="flex items-start gap-3">
                <Clock className="w-4 h-4 text-leaf mt-1 shrink-0" />
                <span data-testid="footer-hours">
                  {CONTACT.hours.map((h) => <span key={h.d} className="block">{h.d}: {h.h}</span>)}
                </span>
              </li>
            </ul>
            <div className="flex gap-3 mt-6">
              <button onClick={openQuote} data-testid="footer-quote-btn" className="px-4 py-2 rounded-full text-sm bg-white/10 hover:bg-white/20 transition-colors">Get Instant Quote</button>
              <button onClick={openBooking} className="px-4 py-2 rounded-full text-sm bg-leaf hover:scale-105 transition-transform">Book Online</button>
            </div>
          </div>
        </div>

        <div className="mt-14 pt-8 border-t border-white/10 flex flex-col md:flex-row gap-4 justify-between text-sm text-white/50">
          <p>© {new Date().getFullYear()} CJB Clean. All rights reserved.</p>
          <p className="flex flex-wrap items-center gap-x-4 gap-y-1">
            {PROMISE.slice(0, 3).map((p) => <span key={p}>{p}</span>)}
            <Link to="/service-terms" data-testid="footer-service-terms-link" className="text-white/60 hover:text-leaf transition-colors">Service Terms</Link>
            <Link to="/service-agreement" data-testid="footer-service-agreement-link" className="text-white/60 hover:text-leaf transition-colors">Service Agreement</Link>
          </p>
        </div>
      </div>
    </footer>
  );
};
